module.exports = __webpack_public_path__ + "img/Spaziergang.8c41f6a1.svg";